export interface UidListIcon {
  iconClass: string;
  tone: 'accent' | 'muted';
}

/**
 * A uid-list entry carrying more than its uid: icons shown before the label and a hover
 * text. The uid alone still drives the label, the reference popover, name resolution and
 * copy, so a plain uid and a decorated one behave the same everywhere else.
 */
export interface UidListItem {
  uid: string;
  icons?: UidListIcon[];
  tooltip?: { title: string; lines: string[] };
}

export function isUidListItem(value: unknown): value is UidListItem {
  return typeof value === 'object' && value !== null && 'uid' in value;
}
